// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"8676725b","643":"abc8c2a7","787":"02ad47e6","818":"1c0415d9"}[chunkId] + ".chunk.js";
};